<template lang="pug">
v-card(:loading="busy")
  template
    v-expand-transition
      grid-table-edit-bar(
        v-if="selection.length"
        v-bind="$props"
        @input="value => $emit('input', value)"

        @refresh="$emit('refresh')"
        @perform="opts => $emit('perform', opts)"

        @clearSelection="$emit('select', [])"
      )

    v-expand-transition
      grid-table-action-bar(
        v-if="!selection.length"
        v-bind="$props"
        @input="value => $emit('input', value)"

        @refresh="$emit('refresh')"
        @perform="opts => $emit('perform', opts)"
      )

  //- GRADE de dados
  grid-table-data.x-data-table(
    v-bind="$props"

    :value="selection"
    @input="value => $emit('select', value)"

    :set="set"
    :showSelect="!!dataSetActions.length"
    height="calc(100vh - 184px)"

    @refresh="$emit('refresh')"
    @perform="opts => $emit('perform', opts)"
  )
</template>

<style>
.v-data-table__checkbox {

}
</style>

<script>
import ActionBar from '@/components/commons/action-bar/ActionBar'

import GridTableActionBar from './GridTableActionBar'
import GridTableEditBar from './GridTableEditBar'
import GridTableData from './GridTableData'

export default {
  components: {
    GridTableActionBar,
    GridTableEditBar,
    GridTableData,

    ActionBar,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    busy: Boolean,

    /**
     * Visibilidade do filtro, alternada por este botão.
     */
    value: Boolean,

    /**
     * Formulário de filtro.
     * @type {Keep.Paper.Design.Form}
     */
    filter: Object,

    /**
     * Coleção dos registros selecionados na grade.
     */
    selection: Array,
  },

  computed: {
    dataSet: vm => vm.entity?.dataSet || {},
    dataSetActions: vm =>
      vm.dataSet?.links?.filter(x => x.rel && x.rel.includes('Action')) || [],
    set: vm => vm.dataSet.sets?.[0] || {},
  },
}
</script>